import React, { useState, useEffect } from 'react';

import * as http from './http';

import ShippersList from './ShippersList';
import ContractsDetail from './ContractsDetail';

const defaultState = {
  loading: false,
  shippers: [],
};

const ShipperContracts = ({ className }) => {
  const [state, setState] = useState(defaultState);

  useEffect(() => {
    const fetch = async () => {
      const { results: shippers } = await http.getShippers();
      setState((state) => ({ ...state, shippers }));
    };

    fetch();
  }, []);

  const { shippers } = state;

  return (
    <div className={className}>
      <div className="shippersList">
        <ShippersList shippers={shippers} />
      </div>
      <div className="shipperContracts">
        <ContractsDetail />
      </div>
    </div>
  );
};

export default ShipperContracts;
